export const BUS_TASK_UPDATE_BEFORE_API_CALL = 'bus-task-update-before-api-call'